import Isotope from "../_lib/isotope/isotope.pkgd.min.js"

document.addEventListener('DOMContentLoaded', () => {

    var grid = document.querySelector('.module-list-picture');
    var isTaxonomy = typeof grid.dataset["sourceId"] !== "undefined"
    if (grid) {
        var iso = new Isotope(grid, {
            itemSelector: 'li',
            percentPosition: true,
            transitionDuration: '0.2s'
        });
        window.bLazy.options.success = function (ele) {
            if (isTaxonomy) {
                iso.reloadItems()
            }
            setTimeout(function () {

                if (isTaxonomy) {
                    iso.arrange()
                } else {
                    iso.layout()
                }
            }, 100)
        }
    }
});